

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginForm.css";
import axios from "axios";
import { GoogleLogin } from "@react-oauth/google";
import {
  bookizapLogo,
  fbLogo,
  appleLogo,
} from "../../../Assets/Icons/IconsIndex";
import { useDispatch, useSelector } from "react-redux";
import {
  login_OTP_request,
  setSuccess,
} from "../../../Redux/Slices/Pages/Auth/LoginSlice";
import { emailValidationSchema } from "../../../Common/Validations/Validations";

const LoginForm = ({ email, setEmail, setShowOtpModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emailError, setEmailError] = useState("");
  console.log(emailError, "email");
  const isSuccess = useSelector((state) => state.login.isSuccess);
  const isLoading = useSelector((state) => state.login.isLoading);

  useEffect(() => {
    if (isSuccess) {
      setShowOtpModal(true);
      dispatch(setSuccess(false));
    }
  }, [isSuccess, setShowOtpModal, dispatch]);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const response = await axios.post(
        "http://127.0.0.1:8000/api/user/auth/google",
        { credential: credentialResponse.credential }
      );
      console.log("Login Success:", response.data);
      navigate("/dashboard");
    } catch (err) {
      console.error("Login failed:", err);
      alert("Google login failed");
    }
  };

  const handleGoogleFailure = (error) => {
    console.error("Google login error", error);
    alert("Google login failed");
  };

  const handleRegisterClick = () => {
    navigate("/register");
  };

  const handleLogin = async () => {
    try {
      await emailValidationSchema.validate(email);
      setEmailError("");
      dispatch(login_OTP_request(email));
    } catch (err) {
      setEmailError(err.message || "Invalid email");
    }
  };

  return (
    <div className="login-container w-full">
      <div className="login-card">
        {/* Logo Section */}
        <div className="logo-section flex items-center justify-center ">
          <img src={bookizapLogo} alt="Bookizap Logo" className=" w-32 h-32" />
        </div>

        {/* Welcome Text */}
        <div className="welcome-section">
          {/* <h2 className="login-title">Welcome Back</h2> */}
          <p className="login-subtitle">Sign in to your account to continue</p>
        </div>

        {/* Form Section */}
        <div className="form-section">
          <div className="input-group">
            <label className="input-label">Email Address</label>
            <div className={`input-wrapper ${emailError ? "error" : ""}`}>
              <div className="input-icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <polyline
                    points="22,6 12,13 2,6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="login-email-input text-center text-xl  "
              />
            </div>
            {emailError && (
              <div className="error-message">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <line
                    x1="15"
                    y1="9"
                    x2="9"
                    y2="15"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <line
                    x1="9"
                    y1="9"
                    x2="15"
                    y2="15"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
                {emailError}
              </div>
            )}
          </div>

          <button
            onClick={handleLogin}
            disabled={isLoading}
            className={`login-button ${isLoading ? "loading" : ""}`}
          >
            {isLoading ? (
              <div className="loading-content">
                <div className="spinner"></div>
                <span>Sending OTP...</span>
              </div>
            ) : (
              <>
                <span>Send OTP</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="5"
                    y1="12"
                    x2="19"
                    y2="12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <polyline
                    points="12,5 19,12 12,19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </>
            )}
          </button>

          {/* Commented out social login section as in original */}
          {/* <div className="divider">
            <span>Or continue with</span>
          </div>

          <div className="social-buttons">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleFailure}
            />
            <button className="social-button">
              <img src={fbLogo} alt="Facebook" />
            </button>
            <button className="social-button">
              <img src={appleLogo} alt="Apple" />
            </button>
          </div> */}
        </div>

        {/* Register Link */}
        <div className="register-section">
          <p className="register-text">
            Don't have an account?
            <button className="register-link" onClick={handleRegisterClick}>
              Create one here
            </button>
          </p>
        </div>
      </div>

      {/* Background Elements */}
      <div className="bg-decoration">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>
    </div>
  );
};

export default LoginForm;
